module.exports = __webpack_public_path__ + "img/QHC_logo.1afac23e.png";